module.exports = __webpack_public_path__ + "static/img/zuyuan.440e5eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/source/zuyuan.png
// module id = I6hV
// module chunks = 1